import { DOCUMENT, isPlatformServer } from '@angular/common';
import {
  CSP_NONCE,
  inject,
  Injectable,
  PLATFORM_ID,
  RendererFactory2,
} from '@angular/core';
import { WWW_CONFIG } from '../models/config.model';

@Injectable({
  providedIn: 'root',
})
export class AdyenDataCollectionService {
  private renderer = inject(RendererFactory2).createRenderer(null, null);
  private document = inject(DOCUMENT);
  private cspNonce = inject(CSP_NONCE);
  private platformId = inject(PLATFORM_ID);
  private wwwConfig = inject(WWW_CONFIG);

  /**
   * Initializes Adyen's data collection script - this should be called regardless of consent status,
   * because it collects device/browser information needed for fraud prevention.
   * More info: https://docs.adyen.com/risk-management/fraud-data-collection/#data-collection-data
   */
  initializeAdyenDataCollection(): void {
    if (
      isPlatformServer(this.platformId) ||
      this.document.getElementById('adyen-data-script')
    )
      return;

    const adyenDataTag = this.renderer.createElement('script');
    adyenDataTag.type = 'text/javascript';
    adyenDataTag.nonce = this.cspNonce;
    adyenDataTag.id = 'adyen-data-script';
    adyenDataTag.src = `https://checkoutshopper-${this.wwwConfig.adyen.environment}.adyen.com/checkoutshopper/assets/js/datacollection/datacollection.js`;
    adyenDataTag.async = true;
    adyenDataTag.defer = true;
    this.renderer.appendChild(this.document.head, adyenDataTag);
  }
}
